<div class="tw-mx-auto tw-mb-10 dir-ltr tw-min-h-[500px]">
  <ngx-monaco-editor
    class="tw-min-h-[500px]"
    [options]="editorOptions"
    [(ngModel)]="code"
    (ngModelChange)="onChanges()"
  >
  </ngx-monaco-editor>
</div>
